// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"7cda09a2","55":"857a1695","437":"857a1695","759":"857a1695"}[chunkId] + ".chunk.css";
};